"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const MenuItemDto_1 = require("./MenuItemDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class MenuItemEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, menuItem) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            type: false,
            order: false
        };
        this._dependencies = dependencies;
        if (menuItem === undefined) {
            this._dto = new MenuItemDto_1.MenuItemDto();
        }
        else if (menuItem instanceof MenuItemDto_1.MenuItemDto) {
            this._dto = new MenuItemDto_1.MenuItemDto(menuItem);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else if (menuItem instanceof MenuItemEntity) {
            this._dto = new MenuItemDto_1.MenuItemDto(menuItem._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new MenuItemDto_1.MenuItemDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getTitle() {
        return this._dto.title;
    }
    setTitle(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = "";
        if (typeof untrustedValue !== "string") {
            throw new Error("setTitle(): Invalid type");
        }
        _untrustedValue = untrustedValue.trim();
        this.clearError("title");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("title", `Title has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.title) {
            return;
        }
        this._dto.title = _untrustedValue;
        this._setIsDirty(true);
    }
    getType() {
        return this._dto.type;
    }
    setType(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = "";
        if (typeof untrustedValue !== "string") {
            throw new Error("setType(): Invalid type");
        }
        _untrustedValue = untrustedValue.trim();
        this.clearError("type");
        this._requiredFieldsSetStatus.type = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("type", "Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("type", `Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.type) {
            return;
        }
        this._dto.type = _untrustedValue;
        this._setIsDirty(true);
    }
    getValue() {
        return this._dto.value;
    }
    setValue(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = "";
        if (typeof untrustedValue !== "string") {
            throw new Error("setValue(): Invalid type");
        }
        _untrustedValue = untrustedValue.trim();
        this.clearError("value");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("value", `Value has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.value) {
            return;
        }
        this._dto.value = _untrustedValue;
        this._setIsDirty(true);
    }
    getTutorialText() {
        return this._dto.tutorialText;
    }
    setTutorialText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = "";
        if (typeof untrustedValue !== "string") {
            throw new Error("setEmail(): Invalid type");
        }
        _untrustedValue = untrustedValue.trim();
        this.clearError("tutorialText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("tutorialText", `Tutorial Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.tutorialText) {
            return;
        }
        this._dto.tutorialText = _untrustedValue;
        this._setIsDirty(true);
    }
    getOrder() {
        return this._dto.order;
    }
    setOrder(untrustedValue) {
        let _untrustedValue;
        this.clearError("order");
        this._requiredFieldsSetStatus.order = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("order", "Order is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("order", "Order is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.order) {
            return;
        }
        this._dto.order = _untrustedValue;
        this._setIsDirty(true);
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.menuItemDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let dto;
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.canSave) {
                    throw new Error("Menu Item is not in a valid state.");
                }
                if (this.isNew) {
                    dto = yield this._dependencies.menuItemDatastore
                        .addAsync(this._dto);
                    this._dto.id = dto.id;
                }
                else {
                    dto = yield this._dependencies.menuItemDatastore
                        .updateAsync(this._dto);
                }
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (this.getId() !== undefined) {
                    yield this._dependencies.menuItemDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.MenuItemEntity = MenuItemEntity;
//# sourceMappingURL=MenuItemEntity.js.map